import { render } from "./ChangeCategory.vue?vue&type=template&id=1b04e5f6"
import script from "./ChangeCategory.vue?vue&type=script&lang=js"
export * from "./ChangeCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__